import { useProfileData } from '../AuthProvider'
import { submitLoginEmail } from '../../utils/devSigninURL'
import Logo from '../Logo'
import Modal from '../Modal'
import * as style from './style.module.scss'
import { navigate } from 'gatsby'
import Link from 'gatsby-link'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useDialogState, DialogDisclosure } from 'reakit/Dialog'

function Menu() {
  const logIn = useDialogState({ baseId: 'logIn' })
  const signUp = useDialogState({ baseId: 'signUp' })

  return (
    <>
      <DialogDisclosure className={style.login} {...logIn}>
        Login
      </DialogDisclosure>
      <DialogDisclosure className={style.cta} {...signUp}>
        Sign up
      </DialogDisclosure>
      {/* Email list signup */}
      <Modal {...signUp}>
        <div className={style.modal}>
          <div>
            <div className={style.title}>
              <h2>Join the list</h2>
              <button
                className={style.buttonClose}
                onClick={() => signUp.hide()}
              >
                Close
              </button>
            </div>
            <p>
              Looking to book the best local pet care? Add your email address
              and we'll let you know as soon as we're live in your area.
            </p>
            <form
              action='https://app.loops.so/api/newsletter-form/clmusgt0c0185l40oqj3wbd3s'
              method='post'
              onSubmit={async (event) => {
                event.preventDefault()
                const response = await fetch(event.target.action, {
                  method: event.target.method,
                  body: new URLSearchParams(new FormData(event.target)),
                })

                const result = await response.json()

                if (result.success) {
                  navigate('/thank-you-for-signing-up')
                  return
                }

                alert(result)
              }}
            >
              <div>
                <label htmlFor={'email'}>Email address</label>
                <input type='email' name='email' required />
                <input
                  type='hidden'
                  name='userGroup'
                  value='Primary nav - signup'
                />
              </div>
              <div>
                <button type='submit'>Sign up for the waitlist</button>
              </div>
            </form>
            <p>
              Already have an account?{' '}
              <DialogDisclosure className={style.link} {...logIn}>
                Login
              </DialogDisclosure>
            </p>
          </div>
          <p className={style.note}>
            By signing up, you agree to receive emails from us. We'll only send
            you emails related to doggos.com and your account.
          </p>
        </div>
      </Modal>

      {/* Login */}
      <Modal {...logIn}>
        <div className={style.modal}>
          <div>
            <div className={style.title}>
              <h2>Login</h2>
              <button
                className={style.buttonClose}
                onClick={() => logIn.hide()}
              >
                Close
              </button>
            </div>
            <p>
              If you already have an account, enter your email address to get a
              login link sent to your inbox.
            </p>
            <form
              onSubmit={async (event) => {
                event.preventDefault()

                const loginResult = await submitLoginEmail(
                  event.target.email.value,
                )
                if (loginResult === 'redirect') {
                  return
                }
                if (loginResult === 'email') {
                  alert('Check your email for a login link.')
                  logIn.hide()
                  return
                }

                alert(
                  "Sorry, we couldn't find an account with that email address.",
                )
              }}
            >
              <label htmlFor='email'>Email address</label>
              <input
                name='email'
                type='email'
                placeholder='Your email address'
              />
              <button>Login</button>
            </form>
            <p>
              Don't have an account?{' '}
              <DialogDisclosure className={style.link} {...signUp}>
                Sign up
              </DialogDisclosure>
            </p>
          </div>
        </div>
      </Modal>
    </>
  )
}

function AccountMenu() {
  const profile = useProfileData({ optional: true })

  return (
    <Link
      to='/dashboard/'
      className={style.accountCircle}
      aria-label='Go to dashboard'
    >
      {profile.name ? profile.name.charAt(0).toUpperCase() : '🎾'}
    </Link>
  )
}

function Header() {
  const profile = useProfileData({ optional: true })

  return (
    <>
      <Helmet>
        {/* Web */}
        <meta property='og:image' content='https://s3.doggos.com/public.png' />
        <meta name='viewport' content='width=device-width, user-scalable=no' />
        <meta property='og:url' content='https://doggos.com' />
        <meta
          name='description'
          content='Find a trustworthy local dog sitter on doggos.com, the independent alternative to Rover and Wag.'
        />
        {/* Social media */}
        <meta property='og:locale' content='en_US' />
        <meta property='og:title' content='Doggos.com' />
        <meta
          property='og:description'
          content='Find a trustworthy local dog sitter on doggos.com.'
        />
      </Helmet>
      <div className={style.headerContainer}>
        <div className={style.headerContent}>
          <Logo />
          <div className={style.profile}>
            <Link to='/search/' className={style.search}>
              <span className={style.desktop}>Browse dog care</span>
              <span className={style.mobile}>Browse</span>
            </Link>

            {profile ? <AccountMenu /> : <Menu />}
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
